var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"job-referral-info-list"},_vm._l((_vm.infoList),function(info,index){return _c('li',{key:index},_vm._l((info),function(child,childIndex){return _c('p',{key:childIndex,class:child.class},[_vm._v(_vm._s(childIndex === 1 ? `(${child.text})` : child.text))])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }